import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContext, AuthContext } from "../App";
import "./css/Login.css";

function Login() {
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const showToast = useContext(ToastContext);
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/login`, { phone, password });

            login(res.data.token, res.data.role);

            showToast("تم تسجيل الدخول بنجاح", "success");

            if (res.data.role === "admin") {
                navigate("/dashboard");
            } else {
                navigate("/home");
            }
        } catch (err) {
            showToast("خطأ في تسجيل الدخول", "danger");
        }
    };

    function convertArabicToEnglishNumbers(value) {
        const arabicNumbers = ['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];
        return value.replace(/[٠-٩]/g, (d) => arabicNumbers.indexOf(d));
    }

    return (
        <div className="login-page d-flex align-items-center ">
            <div className="login-card  text-right p-4  ">
                <div className="text-center mb-4">
                    <img src="the_force_gym_logo.jpg" alt="Gym Logo" className="login-logo mb-2" />
                    <h2 className="login-title">تسجيل الدخول إلى Gym</h2>
                </div>
                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label className="form-label">رقم الهاتف</label>
                        <input
                            type="text"
                            className="form-control"
                            value={phone}
                            onChange={(e) => {
                                const englishValue = convertArabicToEnglishNumbers(e.target.value);
                                setPhone(englishValue);
                            }}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">كلمة المرور</label>
                        <input
                            type="password"
                            className="form-control"
                            value={password}
                            onChange={(e) => {
                                const englishValue = convertArabicToEnglishNumbers(e.target.value);
                                setPassword(englishValue);
                            }}
                            required
                        />
                        <div className="forgot-password text-right mt-2">
                            <a href="/forgot-password">هل نسيت كلمة السر؟</a>
                        </div>
                    </div>

                    <button type="submit" className="btn btn-primary w-100">
                        دخول
                    </button>
                </form>
                <p className="text-center mt-3 text-muted small">
                    © 2025 Force Gym
                </p>
            </div>
        </div>
    );
}

export default Login;
